import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {setCoeffList, setShowModal} from "../../../services/redux/actions/app-actions";
import {Box, Checkbox, FormControl, FormControlLabel, InputLabel, NativeSelect,} from "@material-ui/core";
import ColorPicker from "../../../components/UI/ColorPicker";
import CustomButton from "../../../components/UI/Button";
import InputText from "../../../components/Form/InputText";
import {addCoefficient} from "../api";
import cookiesService from "../../../services/cookiesService";
import {useCustomSnackbar} from "../../../utils/hooks/useCustomSnackbar";
import {bandsOverlap, OPEN_BAND_TO} from "../utils";

const cookiesServiceInstance = cookiesService.getService();
const AddCoeffModal = ({type, saleDept, kpiHunterTypeId, coeffList = []}) => {
  const dispatch = useDispatch();
  const [openBand, setOpenBand] = useState(false);
  const [changeState, setChangeState] = useState({
    color_code: "",
    percents_from: 0,
    percents_to: 0,
    value: 0,
    sale_department_id: saleDept[0].sale_department_id,
    kpi_hunter_type_id: kpiHunterTypeId,
  });
  const {addDefaultSnack, addCloseSnack} = useCustomSnackbar();
  const {position_code} = cookiesServiceInstance.getUserData();

  const handleAdd = () => {
    if (changeState.percents_from > changeState.percents_to) {
      addCloseSnack('Процент "от" не должен превышать процент "до"!');
      return;
    }
    if (bandsOverlap(changeState.percents_from, changeState.percents_to, coeffList)) {
      addCloseSnack("Диапазон пересекается с уже существующим бэндом!");
      return;
    }
    addCoefficient(changeState, type)
      .then((res) => {
        dispatch(setCoeffList(res));
        dispatch(setShowModal(false));
        addDefaultSnack("Коэффициент успешно Добавлен");
      })
      .catch(() => {
      });
  };
  const handleChange = (e) => {
    setChangeState({
      ...changeState,
      [e.target.name]: +e.target.value,
    });
  };
  const handleChangeColor = (e) => {
    setChangeState({
      ...changeState,
      color_code: e?.hex,
    });
  };
  const handleOpenBandChange = (e) => {
    const checked = e.target.checked;
    setOpenBand(checked);
    setChangeState({
      ...changeState,
      percents_to: checked ? OPEN_BAND_TO : 0,
    });
  };

  return (
    <Box sx={{width: 400}}>
      <Box sx={{display: "grid"}}>
        {position_code === "SALE_HEAD_HEAD" ||
        position_code === "SALE_AUDITOR" ? (
          <FormControl style={{minWidth: "200px"}}>
            <InputLabel htmlFor="select-sd" shrink>
              ОП
            </InputLabel>
            <NativeSelect
              onChange={handleChange}
              inputProps={{
                name: "sale_department_id",
                id: "select-sd",
              }}
            >
              {saleDept.map((el) => {
                return (
                  <option
                    value={el.sale_department_id}
                    key={el.sale_department_id}
                  >
                    {el.sale_department_name}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
        ) : null}
        <InputText
          name="value"
          label="Значение коэффициента"
          shrink={false}
          type="number"
          value={changeState.value || null}
          onChange={handleChange}
          fullWidth={true}
        />
        <InputText
          name="percents_from"
          label="Диапазон коэффициента от"
          shrink={false}
          type="number"
          value={changeState.percents_from || null}
          onChange={handleChange}
          fullWidth={true}
        />
        <InputText
          name="percents_to"
          label="Диапазон коэффициента до"
          shrink={false}
          type="number"
          disabled={openBand}
          value={openBand ? OPEN_BAND_TO : changeState.percents_to || null}
          onChange={handleChange}
          fullWidth={true}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={openBand}
              onChange={handleOpenBandChange}
              color="primary"
            />
          }
          label="Верхний бэнд (100 и более)"
        />
        <ColorPicker
          comColor={changeState.color_code}
          setComColor={(val) => {
            handleChangeColor(val);
          }}
        />
      </Box>
      <Box sx={{width: 200, marginRight: "auto", marginTop: "20px"}}>
        <CustomButton btnText="Добавить" handleClick={handleAdd}/>
      </Box>
    </Box>
  );
};

export default AddCoeffModal;
